import { InjectionToken } from '@angular/core';
import { ShareButtonsConfig } from './share.models';

export const CONFIG = new InjectionToken<ShareButtonsConfig>('CONFIG');
